const DEFAULT_ENVIRONMENT = 'production';
const DEV_ENVIRONMENT = 'development';

export { DEFAULT_ENVIRONMENT, DEV_ENVIRONMENT };
//# sourceMappingURL=constants.js.map
